"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Align", {
  enumerable: true,
  get: function get() {
    return _Menu.Align;
  }
});
exports.FocusMenu = FocusMenu;
exports.default = void 0;

var _core = require("@clayui/core");

var _shared = require("@clayui/shared");

var _classnames = _interopRequireDefault(require("classnames"));

var _react = _interopRequireWildcard(require("react"));

var _Action = _interopRequireDefault(require("./Action"));

var _Caption = _interopRequireDefault(require("./Caption"));

var _Divider = _interopRequireDefault(require("./Divider"));

var _DropDownContext = require("./DropDownContext");

var _Group = _interopRequireDefault(require("./Group"));

var _Help = _interopRequireDefault(require("./Help"));

var _Item = _interopRequireDefault(require("./Item"));

var _ItemList = _interopRequireDefault(require("./ItemList"));

var _Menu = _interopRequireWildcard(require("./Menu"));

var _Search = _interopRequireDefault(require("./Search"));

var _Section = _interopRequireDefault(require("./Section"));

var _excluded = ["children"],
    _excluded2 = ["active", "alignmentByViewport", "alignmentPosition", "children", "className", "closeOnClick", "closeOnClickOutside", "containerElement", "defaultActive", "filterKey", "hasLeftSymbols", "hasRightSymbols", "items", "menuElementAttrs", "menuHeight", "menuWidth", "offsetFn", "onActiveChange", "renderMenuOnClick", "role", "trigger"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Collection = _core.__NOT_PUBLIC_COLLECTION.Collection;

var List = /*#__PURE__*/_react.default.forwardRef(function List(_ref, ref) {
  var children = _ref.children,
      otherProps = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_react.default.createElement("ul", _extends({}, otherProps, {
    className: "list-unstyled",
    ref: ref
  }), children);
});

var counter = 0;

function ClayDropDown(_ref2) {
  var active = _ref2.active,
      alignmentByViewport = _ref2.alignmentByViewport,
      alignmentPosition = _ref2.alignmentPosition,
      children = _ref2.children,
      className = _ref2.className,
      _ref2$closeOnClick = _ref2.closeOnClick,
      closeOnClick = _ref2$closeOnClick === void 0 ? false : _ref2$closeOnClick,
      closeOnClickOutside = _ref2.closeOnClickOutside,
      _ref2$containerElemen = _ref2.containerElement,
      ContainerElement = _ref2$containerElemen === void 0 ? 'div' : _ref2$containerElemen,
      _ref2$defaultActive = _ref2.defaultActive,
      defaultActive = _ref2$defaultActive === void 0 ? false : _ref2$defaultActive,
      filterKey = _ref2.filterKey,
      hasLeftSymbols = _ref2.hasLeftSymbols,
      hasRightSymbols = _ref2.hasRightSymbols,
      items = _ref2.items,
      menuElementAttrs = _ref2.menuElementAttrs,
      menuHeight = _ref2.menuHeight,
      menuWidth = _ref2.menuWidth,
      offsetFn = _ref2.offsetFn,
      onActiveChange = _ref2.onActiveChange,
      _ref2$renderMenuOnCli = _ref2.renderMenuOnClick,
      renderMenuOnClick = _ref2$renderMenuOnCli === void 0 ? false : _ref2$renderMenuOnCli,
      _ref2$role = _ref2.role,
      role = _ref2$role === void 0 ? 'menu' : _ref2$role,
      trigger = _ref2.trigger,
      otherProps = _objectWithoutProperties(_ref2, _excluded2);

  var triggerElementRef = (0, _react.useRef)(null);
  var menuElementRef = (0, _react.useRef)(null);

  var _useState = (0, _react.useState)(!renderMenuOnClick),
      _useState2 = _slicedToArray(_useState, 2),
      initialized = _useState2[0],
      setInitialized = _useState2[1];

  var _useControlledState = (0, _shared.useControlledState)({
    defaultName: 'defaultActive',
    defaultValue: defaultActive,
    handleName: 'onActiveChange',
    name: 'active',
    onChange: onActiveChange,
    value: active
  }),
      _useControlledState2 = _slicedToArray(_useControlledState, 2),
      internalActive = _useControlledState2[0],
      setInternalActive = _useControlledState2[1];

  var _useState3 = (0, _react.useState)(''),
      _useState4 = _slicedToArray(_useState3, 2),
      search = _useState4[0],
      setSearch = _useState4[1];

  var ariaControls = (0, _react.useMemo)(function () {
    counter++;
    return "clay-dropdown-menu-".concat(counter);
  }, []);
  var openMenu = (0, _react.useCallback)(function (value) {
    if (!initialized) {
      setInitialized(true);
    }

    setInternalActive(value);
  }, [initialized]);

  var _useNavigation = (0, _shared.useNavigation)({
    activation: 'manual',
    containerRef: menuElementRef,
    loop: true,
    orientation: 'vertical',
    typeahead: true,
    visible: internalActive
  }),
      navigationProps = _useNavigation.navigationProps;

  return /*#__PURE__*/_react.default.createElement(ContainerElement, _extends({}, otherProps, {
    className: (0, _classnames.default)('dropdown', className)
  }), /*#__PURE__*/_react.default.cloneElement(trigger, {
    'aria-controls': ariaControls,
    'aria-expanded': internalActive,
    'aria-haspopup': 'true',
    className: (0, _classnames.default)('dropdown-toggle', trigger.props.className),
    onClick: function onClick(event) {
      if (trigger.props.onClick) {
        trigger.props.onClick(event);
      }

      openMenu(!internalActive);
    },
    onKeyDown: function onKeyDown(event) {
      if (trigger.props.onKeyDown) {
        trigger.props.onKeyDown(event);
      }

      if (event.key === _shared.Keys.Spacebar) {
        openMenu(!internalActive);
      }

      if (event.key === _shared.Keys.Down) {
        event.preventDefault();
        event.stopPropagation();
        openMenu(true);
      }

      if (internalActive && event.key === _shared.Keys.Down) {
        event.preventDefault();
        event.stopPropagation();
        var list = (0, _shared.getFocusableList)(menuElementRef);

        if (list.length) {
          list[0].focus();
        }
      }

      if ([_shared.Keys.Spacebar, _shared.Keys.Down].includes(event.key)) {
        event.preventDefault();
      }
    },
    ref: function ref(node) {
      triggerElementRef.current = node; // Call the original ref, if any.

      var ref = trigger.ref;

      if (typeof ref === 'function') {
        ref(node);
      }
    }
  }), initialized && /*#__PURE__*/_react.default.createElement(_Menu.default, _extends({}, menuElementAttrs, {
    active: internalActive,
    alignElementRef: triggerElementRef,
    alignmentByViewport: alignmentByViewport,
    alignmentPosition: alignmentPosition,
    closeOnClickOutside: closeOnClickOutside,
    hasLeftSymbols: hasLeftSymbols,
    hasRightSymbols: hasRightSymbols,
    height: menuHeight,
    id: ariaControls,
    offsetFn: offsetFn,
    onActiveChange: setInternalActive,
    onKeyDown: function onKeyDown(event) {
      if (menuElementAttrs !== null && menuElementAttrs !== void 0 && menuElementAttrs.onKeyDown) {
        menuElementAttrs.onKeyDown(event);
      }

      if (event.key === _shared.Keys.Tab) {
        event.preventDefault();
        openMenu(false);
        var list = Array.from(document.querySelectorAll(_shared.FOCUSABLE_ELEMENTS.join(',')));
        var position = list.indexOf(triggerElementRef.current);
        var nextElement = list[position + 1];

        if (nextElement) {
          nextElement.focus();
        }
      }

      navigationProps.onKeyDown(event);
    },
    ref: menuElementRef,
    suppress: [triggerElementRef, menuElementRef],
    triggerRef: triggerElementRef,
    width: menuWidth
  }), /*#__PURE__*/_react.default.createElement(FocusMenu, {
    condition: internalActive,
    onRender: function onRender() {
      // After a few milliseconds querying the elements in the DOM
      // inside the menu. This especially when the menu is not
      // rendered yet only after the menu is opened, React needs
      // to commit the changes to the DOM so that the elements are
      // visible and we can move the focus.
      setTimeout(function () {
        var list = (0, _shared.getFocusableList)(menuElementRef);

        if (list.length) {
          list[0].focus();
        }
      }, 10);
    }
  }, /*#__PURE__*/_react.default.createElement(_DropDownContext.DropDownContext.Provider, {
    value: {
      close: function close() {
        var _triggerElementRef$cu;

        setInternalActive(false);
        (_triggerElementRef$cu = triggerElementRef.current) === null || _triggerElementRef$cu === void 0 ? void 0 : _triggerElementRef$cu.focus();
      },
      closeOnClick: closeOnClick,
      filterKey: filterKey,
      onSearch: setSearch,
      search: search,
      tabFocus: false
    }
  }, children instanceof Function ? /*#__PURE__*/_react.default.createElement(Collection, {
    as: List,
    items: items,
    role: role
  }, children) : children))));
}

function FocusMenu(_ref3) {
  var children = _ref3.children,
      condition = _ref3.condition,
      onRender = _ref3.onRender;
  (0, _react.useEffect)(function () {
    if (condition) {
      onRender();
    }
  }, [condition]);
  return children;
}

ClayDropDown.Action = _Action.default;
ClayDropDown.Caption = _Caption.default;
ClayDropDown.Divider = _Divider.default;
ClayDropDown.Group = _Group.default;
ClayDropDown.Help = _Help.default;
ClayDropDown.Menu = _Menu.default;
ClayDropDown.Item = _Item.default;
ClayDropDown.ItemList = _ItemList.default;
ClayDropDown.Search = _Search.default;
ClayDropDown.Section = _Section.default;
var _default = ClayDropDown;
exports.default = _default;